import toast from 'react-hot-toast';
import InfiniteScroll from 'react-infinite-scroll-component';

import React, { useCallback, useEffect, useRef, useState } from 'react';

//shared component

//service configuration
import { axiosInstance } from 'shared/services/http.service';

//interfaces

//component

//theme second
import { Message } from 'feature/chatbot/interface/chatbot';
import { CloseIcon, ScaleBoatIcon, SendIcon } from 'shared/icon/icon';

interface IProps {
    onClose: () => void;
    getToken: () => Promise<{ token: string, expiry: string, url: string } | null>;
    token: { token: string, expiry: string, url: string }
}



const ScaleDemo: React.FC<IProps> = ({ onClose, getToken, token }) => {
    const [messages, setMessages] = useState<Message[]>([{ role: 'assistant', text: 'How can I help you?' }]);
    const [typeLoading, setTypeLoading] = useState(false)
    const [messageText, setMessageText] = useState('');
    const [loading, setLoading] = useState(false)

    const lastMessageRef = useRef<HTMLDivElement | null>(null);
    // type ThemeType = 'first' | 'second' | 'third' | 'four';
    // const [type, setType] = useState<ThemeType>('first');


    // useEffect(() => {
    //     const queryString = window.location.search;
    //     const urlParams = new URLSearchParams(queryString);
    //     const paramValue = urlParams.get('theme');
    //     setType(paramValue as ThemeType || 'first');
    // }, []);



    // Function to send a message to the parent window to close the chatbot
    const closeChatbot = () => {
        window.parent.postMessage({ action: 'closeChatbot' }, '*');
    };




    const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!messageText.trim()) return;
        const newUserMessage: Message = {
            role: 'user',
            text: messageText
        };

        setMessages(prevMessages => [...prevMessages, newUserMessage]);
        const payload = {
            queryInput: {
                text: {
                    text: messageText,
                    languageCode: "de"
                }
            }
        }
        setMessageText('');
        const fetchedToken = await getToken();

        if (!fetchedToken) return;
        try {
            setTypeLoading(true)
            setLoading(true)
            const data = await axiosInstance.post(`https://dialogflow.googleapis.com/v2/${token.url}:detectIntent?access_token=${token.token}`, payload);
            const botMessage: Message = {
                role: 'assistant',
                text: data.data.queryResult?.fulfillmentText
            }
            setMessages(prevMessages => [...prevMessages, botMessage]);
            setLoading(false)
            setTypeLoading(false)
        } catch (error) {
            toast.error('Failed to communicate right now.');
            setTypeLoading(false)
            setLoading(false)
        }
    }, [getToken, messageText, token]);

    useEffect(() => {
        if (lastMessageRef?.current) {
            lastMessageRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages, typeLoading]);

    return (
        <div className='App flex items-center justify-center w-full my-0 mx-auto'>
            <div className='w-full relative flex flex-col'
            >
                <div className='bg-[#25ADD0] flex items-center h-[72px] py-[13.5px] px-[15px]'>
                    <ScaleBoatIcon className="w-[40px] h-[40px] mr-[16px]" />
                    <div className='flex items-center justify-between w-[calc(100%-56px)]'>
                        <p className='font-barlow flex flex-col text-white'>
                            <span className='text-[18px] font-semibold leading-7'>Eyeable</span>
                            <span className='text-[13px] leading-[18px]'>Online</span>
                        </p>
                        <span onClick={onClose || closeChatbot} className='cursor-pointer'>
                            <CloseIcon className="w-[20px] h-[20px]" />
                        </span>
                    </div>
                </div>
                <div className={`flex flex-col bg-white`}>
                    <div id="message-list" className="infinite-scroll-component relative overflow-auto ">
                        <InfiniteScroll
                            dataLength={messages.length}
                            next={() => { }}
                            hasMore={false}
                            loader={circularLoader()}
                            style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 136px)', maxHeight: '247px', padding: '30px' }}
                            scrollableTarget="message-list"
                            scrollThreshold={1}
                        >
                            {messages.length > 0 && messages.map((message, index) => (
                                <div key={index} ref={index === messages.length - 1 ? lastMessageRef : null} className={`flex ${message.role === 'user' ? 'flex-row-reverse' : ''} font-barlow mb-[16px] relative`}>
                                    {message.role === 'assistant' && (
                                        <div className="w-[24px] h-[24px] flex items-center justify-center absolute top-[-11.5px] left-[-12.5px] bg-[#00A5CB] rounded-full">
                                            <ScaleBoatIcon className='w-[12px] h-[12px]' />
                                        </div>
                                    )}
                                    <div className={`${message.role === 'user' ? 'bg-[#00A5CB] self-end] text-white' : 'bg-[#F2F2F2] text-black self-start'} px-[16px] pt-[8px] pb-[10px] rounded-[4px] max-w-[calc(100%-20px)]`}>
                                        <p className='break-words font-barlow text-[15px] leading-[21px] font-regular'>{renderMessageWithLinks(message.text)}</p>
                                    </div>
                                </div>
                            ))}
                            {typeLoading && (
                                <div className="flex relative rounded-[4px]">
                                    <div className="w-[24px] h-[24px] flex items-center justify-center absolute top-[-11.5px] left-[-12.5px] bg-[#00A5CB] rounded-full">
                                        <ScaleBoatIcon className='w-[12px] h-[12px]' />
                                    </div>
                                    <div className="bg-[#F2F2F2] flex items-center justify-center rounded-[5px] px-[16px] pt-[14px] pb-[16px] w-[52px] h-[34px]">
                                        <div className="typing-loader" />
                                    </div>
                                </div>
                            )}
                        </InfiniteScroll>
                    </div>
                </div>
                <form onSubmit={handleSubmit} className="text-[15px] h-[64px] items-center border-t-[1px] border-[#EBEBEB] flex py-[10px] pr-[15px] pl-[20px] bg-white font-barlow ">
                    <input
                        type="text"
                        autoFocus={true}
                        placeholder="Write a message..."
                        className={`placeholder-black w-full flex-1 pr-[10px] p-3 bg-white border border-gray-300  border-none outline-none text-black`}
                        value={messageText}
                        maxLength={256}
                        onChange={(e) => {
                            setMessageText(e.target.value);
                        }}
                    />
                    <button type='submit' className='flex items-center justify-end w-[25px] min-w-[25px] h-[25px] w-[20px] h-[20px]' disabled={loading}>
                        <SendIcon className='fill-[#25ADD0]' />
                    </button>
                </form>
            </div >
        </div >
    );
};

const renderMessageWithLinks = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
        // If the part matches the URL pattern, render it as a clickable link
        if (part.match(urlRegex)) {
            return (
                <a key={index} href={part} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">
                    {part}
                </a>
            );
        }
        // Otherwise, render the text as it is
        return part;
    });
};

const circularLoader = () => (
    <div className="flex justify-center">
        <div className="circular-loader"></div>
    </div>
);

export default ScaleDemo;
